import moment from 'moment';
import { getRoomDetail, getRoomReportDownLoad } from '../services/report';
import { getZoneTreeData } from '../services/calender';

export default {
  namespace: 'roomReport',
  state: {
    startTime: moment()
      .startOf('day')
      .valueOf(),
    endTime: moment()
      .endOf('day')
      .valueOf(),
    meetingName: '',
    pageNo: 1,
    pageSize: 10,
    searchData: [],
    meetingTreeData: { child: [] },
    meetingSearchInfo: {
      meetingType: undefined,
      meetingDevice: undefined,
      moreMeeting: []
    },
    dropVis: false,
    allMoreMenu: [
      'main_meeting_time_length',
      'main_meeting_attends_list',
      'main_room_capacity',
      'main_meeting_sign_rate',
      'report_roomDetail_unSignNames',
      'main_meeting_disuse',
      'report_abnormal_extend',
      'report_abnormal_early_end',
      'resource_name_meeting_type',
      're_cycle_meeting'
    ],
    indeterminate: false,
    checkAll: false,
    moreMenu: [],
    checkMenu: []
  },
  reducers: {
    setState(state, { payload }) {
      return { ...state, ...payload };
    },
    setMeetingTreeData(state, { meetingTreeData }) {
      return { ...state, meetingTreeData };
    }
  },
  effects: {
    *search(undefined, { call, select, put }) {
      const { token } = yield select(state => state.login);
      let startTime = yield select(state => state.roomReport.startTime);
      let endTime = yield select(state => state.roomReport.endTime);
      let meetingName = yield select(state => state.roomReport.meetingName);
      let meetingSearchInfo = yield select(
        state => state.roomReport.meetingSearchInfo
      );
      let pageNo = yield select(state => state.roomReport.pageNo);
      let pageSize = yield select(state => state.roomReport.pageSize);
      let id = meetingSearchInfo.moreMeeting;
      let roomIds = (id && id.length > 0 && id.join(';')) || '';
      const { locale } = yield select(state => state.i18n);

      // let data = yield call(getRoomReport, {
      //   startDate: startTime.startOf('day').valueOf(),
      //   endDate: endTime.endOf('day').valueOf(),
      //   meetingName,
      //   roomIds,
      //   locale,
      //   pageNo,
      //   pageSize,
      //   token
      // });
      /**
       * 查询会议室详情
       */
      let data = yield call(getRoomDetail, {
        startDate: startTime.startOf('day').valueOf(),
        endDate: endTime.endOf('day').valueOf(),
        meetingName,
        roomIds,
        locale,
        pageNo,
        pageSize,
        token
      });
      if (data) {
        yield put({
          type: 'setState',
          payload: { searchData: data.data || [] }
        });
      }
    },
    *changePage({ payload }, { call, select, put }) {
      yield put({ type: 'setState', payload: { ...payload } });
      const { token } = yield select(state => state.login);
      let startTime = yield select(state => state.roomReport.startTime);
      let endTime = yield select(state => state.roomReport.endTime);
      let meetingName = yield select(state => state.roomReport.meetingName);
      let meetingSearchInfo = yield select(
        state => state.roomReport.meetingSearchInfo
      );
      let pageNo = yield select(state => state.roomReport.pageNo);
      let pageSize = yield select(state => state.roomReport.pageSize);
      let id = meetingSearchInfo.moreMeeting;
      let roomIds = (id && id.length > 0 && id.join(';')) || '';
      const { locale } = yield select(state => state.i18n);
      let data = yield call(getRoomDetail, {
        startDate: startTime.startOf('day').valueOf(),
        endDate: endTime.endOf('day').valueOf(),
        meetingName,
        roomIds,
        locale,
        pageNo,
        pageSize,
        token
      });
      if (data) {
        yield put({
          type: 'setState',
          payload: { searchData: data.data || [] }
        });
      }
    },
    *downloadRoom({}, { select, call }) {
      const { token } = yield select(state => state.login);
      let startTime = yield select(state => state.roomReport.startTime);
      let endTime = yield select(state => state.roomReport.endTime);
      let meetingName = yield select(state => state.roomReport.meetingName);
      let meetingSearchInfo = yield select(
        state => state.roomReport.meetingSearchInfo
      );
      let id = meetingSearchInfo.moreMeeting;
      let roomIds = (id && id.length > 0 && id.join(';')) || '';
      const { locale } = yield select(state => state.i18n);
      yield call(getRoomReportDownLoad, {
        startDate: startTime.startOf('day').valueOf(),
        endDate: endTime.endOf('day').valueOf(),
        roomNames: meetingName,
        roomIds,
        locale,
        token
      });
    },
    *getMeetingTreeDataForSearch({}, { select, put, call }) {
      const { locale } = yield select(state => state.i18n);
      const data = yield call(getZoneTreeData, {
        pageNo: '',
        pageSize: '',
        startTime: moment()
          .startOf('day')
          .valueOf(),
        endTime: '',
        flag: 3,
        otherRoomIds: '',
        audit: '',
        name: '',
        deviceIds: '',
        teaIds: '',
        lang: locale
      });
      yield put({ type: 'setMeetingTreeData', meetingTreeData: data.data });
    }
  },
  subscriptions: {
    set({ dispatch, history }) {
      return history.listen(rooter => {
        const fromDetail = rooter.query && rooter.query.detail;
        if (rooter.pathname.indexOf('roomReport') > -1) {
          dispatch({ type: 'getMeetingTreeDataForSearch' });
          if (fromDetail !== 'true') {
            let p = {
              startTime: moment().subtract(1, 'days'),
              endTime: moment().subtract(1, 'days'),
              meetingName: '',
              pageNo: 1,
              pageSize: 10,
              searchData: [],
              meetingTreeData: { child: [] },
              meetingSearchInfo: {
                meetingType: undefined,
                meetingDevice: undefined,
                moreMeeting: []
              }
            };
            dispatch({ type: 'setState', payload: p });
          }
        }
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/models/roomReport.js